module.exports = __webpack_public_path__ + "static/img/Checked.e6937f77.svg";